(function () {
  var REVIEW_SAMPLE_HANDLE = 'review';
  var OPTIONAL_EMAIL_FALLBACK = 'no-reply@ronron.site';

  function hideNode(node) {
    if (node) {
      node.style.display = 'none';
      node.setAttribute('aria-hidden', 'true');
    }
  }

  function normalize(text) {
    return String(text || '').replace(/\s+/g, '');
  }

  function getProductHandle() {
    if (window.GPOConfigs && window.GPOConfigs.product && window.GPOConfigs.product.handle) {
      return String(window.GPOConfigs.product.handle);
    }

    var match = window.location.pathname.match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : '';
  }

  function isReviewSamplePage() {
    return getProductHandle() === REVIEW_SAMPLE_HANDLE;
  }

  function hideRivyoReviewsOnSamplePage() {
    if (!isReviewSamplePage()) return;

    document.body.classList.add('ronron-hide-rivyo-review');

    document.querySelectorAll([
      '#wc_review_section',
      '.wc_product_review_section',
      '.wc_product_review_badge',
      '.rivyoReviewWidget',
    ].join(',')).forEach(hideNode);
  }

  function hideRivyoQa() {
    var root = document.getElementById('wc_review_section');
    if (!root) return;

    root.querySelectorAll('.wc_rivyo_tab_toggle[data-tab="Question"]').forEach(function (button) {
      hideNode(button.closest('li') || button);
    });

    root.querySelectorAll('.wc_questions_tab').forEach(hideNode);

    root.querySelectorAll('.wc_review_summary_action .wcRivyoFeedback').forEach(function (button) {
      var label = normalize(button.textContent);
      if (label.indexOf('質問') !== -1 || /question/i.test(label)) {
        hideNode(button.closest('li') || button);
      }
    });
  }

  function getFieldLabel(field) {
    var wrapper = field.closest('.wc_rivyo_form_col, .wc_review_form_filed, .wc_attribute_contain');
    if (wrapper) {
      var wrapperLabel = wrapper.querySelector('label');
      if (wrapperLabel) return wrapperLabel;
    }

    if (field.id) {
      return document.querySelector('label[for="' + field.id + '"]');
    }

    return null;
  }

  function setLabelHtml(field, html) {
    var label = getFieldLabel(field);
    if (label && (label.getAttribute('data-ronron-label-html') !== html || label.innerHTML !== html)) {
      label.innerHTML = html;
      label.setAttribute('data-ronron-label-html', html);
    }
  }

  function setFieldValue(field, value) {
    var descriptor = Object.getOwnPropertyDescriptor(Object.getPrototypeOf(field), 'value');
    if (descriptor && descriptor.set) {
      descriptor.set.call(field, value);
    } else {
      field.value = value;
    }
    field.dispatchEvent(new Event('input', { bubbles: true }));
    field.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function hasReviewRequiredValues(form) {
    var nameField = form.querySelector('input[name="name"], input#name');
    var bodyField = form.querySelector('textarea[name="review_body"], textarea#review_body');
    var ratingField = form.querySelector('input[name="wc_rating"]:checked');

    return Boolean(
      nameField && nameField.value.trim()
      && bodyField && bodyField.value.trim()
      && ratingField && Number(ratingField.value) > 0
    );
  }

  function primeOptionalEmailForRivyo(form) {
    var emailField = form.querySelector('input[name="email"], input#email');
    if (!emailField || emailField.value.trim() || !hasReviewRequiredValues(form)) return;

    setFieldValue(emailField, OPTIONAL_EMAIL_FALLBACK);
    emailField.setAttribute('data-ronron-autofilled-email', 'true');
  }

  function makeRivyoReviewFormSafer() {
    document.querySelectorAll('form.wc_rivyo_form_contain').forEach(function (form) {
      var nameField = form.querySelector('input[name="name"], input#name');
      if (nameField) {
        setLabelHtml(nameField, 'ニックネーム<em>*</em>');
        nameField.setAttribute('autocomplete', 'nickname');
        if (!nameField.getAttribute('placeholder')) {
          nameField.setAttribute('placeholder', '例：ロンロン');
        }
      }

      var emailField = form.querySelector('input[name="email"], input#email');
      if (emailField) {
        emailField.required = false;
        emailField.removeAttribute('required');
        emailField.removeAttribute('aria-required');
        emailField.setAttribute('aria-label', 'メールアドレス（任意）');
        if (!emailField.getAttribute('placeholder')) {
          emailField.setAttribute('placeholder', '任意');
        }
        setLabelHtml(emailField, 'メールアドレス（任意）');
      }

      if (form.getAttribute('data-ronron-email-optional') !== 'true') {
        form.setAttribute('data-ronron-email-optional', 'true');
      }

      if (form.getAttribute('data-ronron-email-autofill-listener') !== 'true') {
        form.setAttribute('data-ronron-email-autofill-listener', 'true');
        form.addEventListener('click', function (event) {
          var submitButton = event.target.closest && event.target.closest('button[type="submit"], .wc_rivyo_form_btn');
          if (submitButton) {
            primeOptionalEmailForRivyo(form);
          }
        }, true);
        form.addEventListener('submit', function () {
          primeOptionalEmailForRivyo(form);
          var currentEmailField = form.querySelector('input[name="email"], input#email');
          if (currentEmailField && !currentEmailField.value.trim()) {
            currentEmailField.required = false;
            currentEmailField.removeAttribute('required');
            currentEmailField.setCustomValidity('');
          }
        }, true);
      }
    });
  }

  function applyRivyoCustomizations() {
    hideRivyoReviewsOnSamplePage();
    hideRivyoQa();
    makeRivyoReviewFormSafer();
  }

  function boot() {
    applyRivyoCustomizations();

    var observer = new MutationObserver(applyRivyoCustomizations);
    observer.observe(document.body, { childList: true, subtree: true });

    window.setTimeout(function () {
      applyRivyoCustomizations();
    }, 15000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
